import {withClass} from '../helpers/react-helpers'
import css from './CustomerPaymentPage.less'
import type {MultiDate} from './date'

interface Base {
    name: string;
    amount: string;
}

interface Item {
    name: string;
    amount: string;
}

export interface Billing {
    base: Base[];
    items: Item[];
    grand_total: StringNum;
    grand_total_value: StringNum;
    total_payments: StringNum;
    total_payments_value: StringNum;
    total_due: StringNum;
    total_due_value: StringNum;
    base_total_value: StringNum;
    error: number;
}

export interface Segment {
    id: number;
    number: number;
    pickup: DateTime;
    dropoff: DateTime;
    stops: Stop[];
    vehicle: Vehicle;
}

export interface Stop {
    id: number;
    letter: string;
    address: string;
}

export interface Vehicle {
    id: number;
    name: string;
    code: string;
    capacity: number;
}

export interface DateTime {
    date: string;
    time: string;
    iso: string
}

export interface Booking {
    key: string
    number: number
    segments: Segment[];
    status: 'cancelled'|'confirmed'|'quote'
}

export interface Company {
    name: string
    address: string
    logo: {
        url: string
        width: number
        height: number
    } | null
}

export interface Customer {
    name: string
}

export interface Currency {
    code: string
    decimal_places: number
}

export interface PaymentRequest {
    amountFormat: string
    amountValue: number
    key: string
    paymentReceivedDate: MultiDate,
    type: 'DUE'|'FIXED'
    source: 'PAYMENT_REQUEST'|'INSTANT_PAY'
}

export type CustomerBillingOptions = {
    hideGratuity: boolean
}

export const Header = withClass('div', css.header)
export const SubHeader = withClass('div', css.subheader)

export interface CustomerPaymentPageProps {
    booking: Booking
    currency: Currency
    billing: Billing|null
    company: Company
    customer: Customer
    request: PaymentRequest
    options: CustomerBillingOptions
}
